import { BadgeProps } from './types';
import { BaseBadge } from './Badge.styles';
import { getIconFromProps, getDefaultText } from './utils';

export const Badge = ({ children, icon, variant = '', ...props }: BadgeProps) => {
  return (
    <BaseBadge data-test={`badge-${variant}`} variant={variant} {...props}>
      {getIconFromProps({ icon, variant })}
      <span data-test={`badge-${variant}-inner`}>{children || getDefaultText(variant)}</span>
    </BaseBadge>
  );
};
